import {
  fetchCurrentUser,
  updateCurrentUser,
  updateDisplayCurrency,
  updateProfileWizardActiveKey,
  logOut,
} from '../routines';
import { DEFAULT_ERROR_MESSAGE } from '../../common/constants/CommonConstants';

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  user: {},
  isUserProfileVisible: false,
  errorMessage: '',
  profileWizardActiveKey: 0,
};

const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case fetchCurrentUser.TRIGGER:
    case updateCurrentUser.TRIGGER:
    case updateDisplayCurrency.TRIGGER:
      return {
        ...state,
        isLoading: true,
      };
    case updateCurrentUser.FAILURE:
    case updateDisplayCurrency.FAILURE:
    case fetchCurrentUser.FAILURE:
      return {
        ...state,
        isLoading: false,
        isError: true,
        isSuccess: false,
        errorMessage:
          action.payload?.message ||
          action.payload?.response?.data?.message ||
          DEFAULT_ERROR_MESSAGE,
      };
    case updateCurrentUser.SUCCESS:
    case updateDisplayCurrency.SUCCESS:
    case fetchCurrentUser.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isError: false,
        isSuccess: true,
        user: {
          ...state.user,
          ...action.payload.user,
        },
      };
    case updateProfileWizardActiveKey.TRIGGER:
      return {
        ...state,
        profileWizardActiveKey: action.payload.activeKey,
      };

    case logOut.SUCCESS:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export default currentUserReducer;
